const initialState = {
  items: [],
  count: 0,
  item: null,
  isLoading: false
};

export function vlfCategoryReducer(state = initialState, action) {
  const { data, vlfCategory: item, type } = action;
  switch (type) {
    case 'VLF_CATEGORY_ERROR':
      return Object.assign({}, state, {
        isLoading: false
      });
    case 'VLF_CATEGORY_CREATE':
      return Object.assign({}, state, {
        item: null,
        isLoading: true
      });
    case 'VLF_CATEGORY_CREATE_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false
      });

    case 'VLF_CATEGORY_GET':
      return Object.assign({}, state, {
        item: null,
        isLoading: true
      });
    case 'VLF_CATEGORY_GET_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false
      });

    case 'VLF_CATEGORIES_GET':
      return Object.assign({}, state, {
        items: [],
        count: 0,
        isLoading: true
      });
    case 'VLF_CATEGORIES_GET_OK':
      return Object.assign({}, state, {
        items: data.items,
        count: data.count,
        isLoading: false
      });

    default:
      return state;
  }
}
